import angular from 'angular';

import ProcessKeyDirective, { selector } from './process-key.directive';

export default angular
    .module('application.directive.process-key', [])
    .directive(selector, ProcessKeyDirective);



// WEBPACK FOOTER //
// ./src/application/directive/process-key/index.js